import CodeCard from "./CodeCard";

export default function CodeColumn({
  title,
  subtitle,
  icon: Icon,
  items,
  kind,
  loading,
  accepted,
  rejected,
  onAccept,
  onReject,
  onHover,
  onLeave,
  favoritesIndex,
  onToggleFavorite,
  onToggleOverride,
  testId,
}) {
  const count = items?.length || 0;

  return (
    <div
      className="col-span-1 flex flex-col h-full bg-[#F4F1EB] rounded-md border border-[#E5E0D8] overflow-hidden min-h-0"
      data-testid={testId}
    >
      <header className="flex items-center justify-between px-4 py-3 border-b border-[#E5E0D8] bg-[#FCFBF9]">
        <div className="flex items-center gap-2 min-w-0">
          {Icon && <Icon size={18} weight="duotone" className="text-[#8C3A27] shrink-0" />}
          <div className="min-w-0">
            <h2 className="font-serif text-lg leading-none tracking-tight text-[#2C332A] truncate">
              {title}
            </h2>
            <p className="text-[10px] uppercase tracking-[0.14em] text-[#5C665A] mt-1 truncate">
              {subtitle}
            </p>
          </div>
        </div>
        <span
          className="font-mono text-xs font-semibold text-[#2C332A] bg-[#EBE7DF] border border-[#E5E0D8] px-2 py-0.5 rounded"
          data-testid={`${testId}-count`}
        >
          {loading ? "…" : count}
        </span>
      </header>

      <div className="flex-1 overflow-y-auto tc-scroll min-h-0">
        {loading ? (
          <div className="p-2 space-y-2">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="tc-pulse m-2 h-24 rounded-md bg-white/60 border border-[#E5E0D8]"
              />
            ))}
          </div>
        ) : count === 0 ? (
          <div className="h-full flex items-center justify-center p-6 text-center">
            <p className="text-xs text-[#5C665A] italic leading-relaxed">
              No codes yet. Paste a trauma note and click <span className="font-medium text-[#2C332A]">Analyze</span>.
            </p>
          </div>
        ) : (
          items.map((item, idx) => (
            <CodeCard
              key={`${item.code}-${idx}`}
              item={item}
              index={idx}
              kind={kind}
              accepted={accepted?.[idx]}
              rejected={rejected?.[idx]}
              onAccept={() => onAccept?.(idx)}
              onReject={() => onReject?.(idx)}
              onHover={onHover}
              onLeave={onLeave}
              isFavorite={!!favoritesIndex?.[`${kind}:${kind === "ais" ? item.ais2015_code || item.code : item.code}`]}
              onToggleFavorite={() => onToggleFavorite?.(item, kind)}
              onToggleOverride={() => onToggleOverride?.(item)}
            />
          ))
        )}
      </div>
    </div>
  );
}
